<template>
    <div class="w-full md:max-w-xl">
        <div class="relative flex items-center bg-white rounded-lg px-4">
            <input
                type="text"
                :value="value"
                @input="$emit('input', $event.target.value)"
                placeholder="Search keywords"
                class="w-full p-4 rounded-lg border-0 text-14 md:text-lg text-onyx font-montserrat font-normal"
            />
            <span class="text-primary">
                <i class="feather icon-search text-18 md:text-2xl"></i>
            </span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SearchInput',
    props: {
        value: {
            type: String,
            default: '',
        },
    },
};
</script>
